/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_ParticipantLiquidNetWorthDto } from '../models/PagedResultDto_ParticipantLiquidNetWorthDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantLiquidNetWorth_CreatUpdateParticipantLiquidNetWorthDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantLiquidNetWorth_CreatUpdateParticipantLiquidNetWorthDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantLiquidNetWorth_ParticipantLiquidNetWorthDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantLiquidNetWorth_ParticipantLiquidNetWorthDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantLiquidNetWorthService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_ParticipantLiquidNetWorth_ParticipantLiquidNetWorthDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantLiquidNetWorthParticipantLiquidNetWorthsList(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_ParticipantLiquidNetWorth_ParticipantLiquidNetWorthDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-liquid-net-worth/participant-liquid-net-worths-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_ParticipantLiquidNetWorth_ParticipantLiquidNetWorthDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantLiquidNetWorth(
        requestBody?: Wealthlane_CustomerService_Dtos_ParticipantLiquidNetWorth_CreatUpdateParticipantLiquidNetWorthDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantLiquidNetWorth_ParticipantLiquidNetWorthDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant-liquid-net-worth',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_ParticipantLiquidNetWorthDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantLiquidNetWorth(
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_ParticipantLiquidNetWorthDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-liquid-net-worth',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_ParticipantLiquidNetWorth_ParticipantLiquidNetWorthDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppParticipantLiquidNetWorth(
        id: string,
        requestBody?: Wealthlane_CustomerService_Dtos_ParticipantLiquidNetWorth_CreatUpdateParticipantLiquidNetWorthDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantLiquidNetWorth_ParticipantLiquidNetWorthDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/participant-liquid-net-worth/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppParticipantLiquidNetWorth(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/participant-liquid-net-worth/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_CustomerService_Dtos_ParticipantLiquidNetWorth_ParticipantLiquidNetWorthDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantLiquidNetWorth1(
        id: string,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantLiquidNetWorth_ParticipantLiquidNetWorthDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-liquid-net-worth/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
